import React from 'react';
import './Thoughts.css';
import content from '../../lib/content';

function Thoughts() {
  const { ps, medium } = content;
  return (
    <div className="thought-container">
      <div className="thought-left">
        <div className="ps-box">
          <h2>{ps.header}</h2>
          <p>{ps.text}</p>
        </div>
        <div
          className="ps-box medium"
          onClick={() => window.open('https://medium.com/@samarthnehe')}
        >
          <h2>{medium.header}</h2>
          <p>{medium.text}</p>
        </div>
      </div>
      <div className="my-thoughts">
        <h1>{ps.thought}</h1>
      </div>
    </div>
  );
}

export default Thoughts;
